import React, { useState } from "react";
import Modal from "../../../../components/Reusable/Modal";
import { useAppDispatch, useAppSelector } from "../../../../hooks/hooks";

import { toast } from "react-toastify";
import { DeleteModalProps } from "../types";
import {
  deleteAirtimePlan,
  fetchAirtimePlans,
} from "../../../../features/auth/store/airtimePlanSlice";
import { RootState } from "../../../../redux/store";

export const DeleteAirtimeModal: React.FC<DeleteModalProps> = ({
  id: airtimePlan,
  isOpen,
  onClose,
}) => {
  const dispatch = useAppDispatch();
  const { currentPage } = useAppSelector(
    (state: RootState) => state.airtimePlans,
  );
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleDelete = async () => {
    if (airtimePlan === null) return;
    setIsSubmitting(true);
    try {
      await dispatch(deleteAirtimePlan(airtimePlan)).unwrap();
      toast.success("Airtime Plan deleted successfully! 🚀");
      onClose();
      dispatch(fetchAirtimePlans({ page: currentPage }));
    } catch (err: any) {
      toast.error(err?.message || "Failed to delete plan");
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!isOpen) {
    return null;
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <h2 className="text-xl font-bold mb-4">Delete Airtime Plan</h2>
      <div className="p-4">
        <p>Are you sure you want to delete this airtime Plan?</p>
        <div className="mt-4 flex justify-end gap-2">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
            disabled={isSubmitting}
          >
            Cancel
          </button>
          <button
            onClick={handleDelete}
            className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
            disabled={isSubmitting}
          >
            {isSubmitting ? "Deleting..." : "Delete"}
          </button>
        </div>
      </div>
    </Modal>
  );
};
